import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'

type UseRouteLoadingOptions = {
  delay?: number
}

export const useRouteLoading = ({ delay = 120 }: UseRouteLoadingOptions = {}) => {
  const router = useRouter()
  const [isRouteLoading, setIsRouteLoading] = useState(false)
  const showLoaderTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const handleRouteChangeStart = () => {
      if (showLoaderTimeoutRef.current) {
        clearTimeout(showLoaderTimeoutRef.current)
      }

      showLoaderTimeoutRef.current = setTimeout(() => {
        setIsRouteLoading(true)
      }, delay)
    }

    const handleRouteChangeEnd = () => {
      if (showLoaderTimeoutRef.current) {
        clearTimeout(showLoaderTimeoutRef.current)
        showLoaderTimeoutRef.current = null
      }

      setIsRouteLoading(false)
    }

    router.events.on('routeChangeStart', handleRouteChangeStart)
    router.events.on('routeChangeComplete', handleRouteChangeEnd)
    router.events.on('routeChangeError', handleRouteChangeEnd)

    return () => {
      if (showLoaderTimeoutRef.current) {
        clearTimeout(showLoaderTimeoutRef.current)
        showLoaderTimeoutRef.current = null
      }

      router.events.off('routeChangeStart', handleRouteChangeStart)
      router.events.off('routeChangeComplete', handleRouteChangeEnd)
      router.events.off('routeChangeError', handleRouteChangeEnd)
    }
  }, [delay, router.events])

  return isRouteLoading
}
